import usePaginationParams from 'app/hooks/usePaginationParams';
import { FilterParams } from 'app/types/Filters';
import { FilterProps } from 'components/Dashboard/types';
import { selectModelsApi } from 'store/exec/execSlice';
import { useAppSelector } from 'store/hooks';

import { Button, Form, Select, Space } from 'antd';
import React from 'react';

const CreditServicesFilter: React.FC<FilterProps> = ({ onApply }) => {
  const modelsApi = useAppSelector(selectModelsApi);
  const [ form ] = Form.useForm<FilterParams>();
  const { modelApiParam, setFilters, clearFilters } = usePaginationParams();

  const onReset = () => {
    form.setFieldValue('modelApi', undefined);
    clearFilters();
  };

  const onFinish = (values: FilterParams) => {
    setFilters(values);
    onApply();
  };

  return (
    <Form
      form={form}
      name="creditServicesFilter"
      layout="vertical"
      requiredMark={false}
      onFinish={onFinish}
      style={{ width: 290 }}
      initialValues={{ modelApi: modelApiParam || undefined }}
    >

      <Form.Item name="modelApi" label="Model API">
        <Select placeholder="Select model API" options={modelsApi} allowClear />
      </Form.Item>

      <Form.Item style={{ textAlign: 'right', marginBottom: 0 }}>
        <Space>
          <Button onClick={onReset}>
            Reset
          </Button>
          <Button type="primary" htmlType="submit">
            Apply
          </Button>
        </Space>
      </Form.Item>
    </Form>
  );
};

export default CreditServicesFilter;
